const loadButtonTop = (topButtonDisable) => {
    if (typeof topButtonDisable === 'undefined') {
        $(document).ready(() => {
            $(window).scroll(() => {
                if ($(window).scrollTop() >= 300) {
                    $('.button__top').addClass('button__top--is-active');
                } else {
                    $('.button__top').removeClass('button__top--is-active');
                }
            });

            $('.button__top').click((e) => {
                e.preventDefault();
                $('body, html').animate(
                    {
                        scrollTop: 0,
                    },
                    333
                );
            });
        });
    }
};

// Module startup
const init = () => {
    // find div that holds pixel height setting for when to show button
    const link = document.querySelector('[data-top-button-disable]');
    let topButtonDisable = null;
    if (link) {
        topButtonDisable = link.getAttribute('data-top-button-disable');
    }
    loadButtonTop(topButtonDisable);
};

export { init };
